import { render } from "./PactoSettingsPage.vue?vue&type=template&id=efa29b46"
import script from "./PactoSettingsPage.vue?vue&type=script&lang=js"
export * from "./PactoSettingsPage.vue?vue&type=script&lang=js"

import "./PactoSettingsPage.vue?vue&type=style&index=0&id=efa29b46&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__